/* BushLine - speak or type (memory rule 203, 11 Oct 2026, "Calculators round 2").
   Any typing box marked data-bl-mic gets the purple microphone inside it, on the right - the same look and pulse as the
   Wind Speed Calculator and the header search. Drawn only where the browser can listen (SpeechRecognition); typing always
   still works. What is said only fills the box - nothing is kept or sent anywhere by this script.
   data-bl-mic="digits" keeps the numbers only ("six oh five six" -> 6056) and respects maxlength (Australian / NZ postcode boxes);
   data-bl-mic="postcode" also keeps single letters ("M 5 H 2 N 2" -> M5H2N2) for boxes that take overseas codes too.
   Each box fires its own input and change events afterwards, so the box's own script reacts as if it was typed.
   data-bl-mic="none" (13 Oct 2026, owner) keeps the box's wrapper and styling but draws NO microphone - the quote-form boxes.
   Re-run window.blMic(root) after adding boxes to the page. */
(function () {
  if (window.blMic) { window.blMic(); return; }
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v4"/></svg>';
  var NUM = { zero: '0', oh: '0', o: '0', nought: '0', one: '1', two: '2', to: '2', too: '2', three: '3', four: '4', for: '4', five: '5', six: '6', seven: '7', eight: '8', ate: '8', nine: '9' };
  /* digits: numbers only. letters too (postcode mode): also keeps single spoken letters, for overseas codes such as M5H 2N2. */
  function digits(t, letters) {
    var out = '', w = String(t).toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/);
    for (var i = 0; i < w.length; i++) {
      if (!w[i]) continue;
      if (/^\d+$/.test(w[i])) out += w[i];
      else if (w[i] === 'double' && NUM[w[i + 1]]) { out += NUM[w[i + 1]] + NUM[w[i + 1]]; i++; }
      else if (letters && /^[a-z]$/.test(w[i]) && w[i] !== 'o') out += w[i].toUpperCase();
      else if (letters && /^[a-z]\d+$|^\d+[a-z]$|^[a-z]\d[a-z]$|^\d[a-z]\d$/.test(w[i])) out += w[i].toUpperCase();
      else if (NUM[w[i]]) out += NUM[w[i]];
    }
    return out;
  }
  function fire(inp) {
    ['input', 'change'].forEach(function (n) { inp.dispatchEvent(new Event(n, { bubbles: true })); });
  }
  function add(inp) {
    if (inp.getAttribute('data-bl-mic-on')) return;
    inp.setAttribute('data-bl-mic-on', '1');
    var f = inp.parentNode;
    if (!f.classList || !f.classList.contains('bl-mic-field')) {
      f = document.createElement('div'); f.className = 'bl-mic-field';
      inp.parentNode.insertBefore(f, inp); f.appendChild(inp);
    }
    if (inp.classList.contains('bl-pc-wide')) f.classList.add('is-wide'); /* the wide Wind Speed-style boxes; form boxes keep their own width */
    if (inp.tagName === 'TEXTAREA') f.classList.add('is-area'); /* note boxes: mic in the top corner, speech is added to what is there */
    function mark() { f.classList.toggle('is-typed', (inp.value || '').trim() !== ''); }
    inp.addEventListener('input', mark); mark();
    if (!SR || inp.getAttribute('data-bl-mic') === 'none') return;
    f.classList.add('has-mic');
    var say = inp.getAttribute('data-bl-mic-say') || 'Say it instead of typing';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'bl-mic';
    b.setAttribute('aria-label', say); b.title = say; b.setAttribute('aria-pressed', 'false'); b.innerHTML = SVG;
    f.appendChild(b);
    var ph = inp.placeholder, rec = null, mode = inp.getAttribute('data-bl-mic'), base = '';
    function done() { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); inp.placeholder = ph; rec = null; }
    b.addEventListener('click', function () {
      if (rec) { try { rec.stop(); } catch (e) { done(); } return; }
      try { rec = new SR(); } catch (e) { rec = null; return; }
      rec.lang = navigator.language || 'en-AU'; rec.interimResults = true; rec.continuous = false; rec.maxAlternatives = 1;
      rec.onresult = function (e) {
        var t = ''; for (var k = 0; k < e.results.length; k++) t += e.results[k][0].transcript;
        t = t.trim();
        if (mode === 'digits' || mode === 'postcode') { t = digits(t, mode === 'postcode'); var m = parseInt(inp.getAttribute('maxlength'), 10); if (m > 0) t = t.slice(0, m); }
        inp.value = base && t ? base + ' ' + t : (t || base); mark();
        if (e.results[e.results.length - 1].isFinal) fire(inp);
      };
      rec.onend = done; rec.onerror = done;
      base = inp.tagName === 'TEXTAREA' ? inp.value.replace(/s+$/, '') : '';
      b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); inp.placeholder = 'Listening…';
      try { rec.start(); } catch (e) { done(); }
    });
  }
  window.blMic = function (root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('input[data-bl-mic],textarea[data-bl-mic]'), add);
  };
  window.blMic.digits = digits;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.blMic(); });
  else window.blMic();
})();
